<template>
  <div class="contaier">
    <div class="top-nvg_box">
      <div class="logo-box" @click="goHome">
        <img alt="" class="img" src="./../assets/img/logo.png" />
      </div>
      <i class="iconfont icon-danlieliebiao" @click="tNvgShow = !tNvgShow"></i>
      <div class="r-nvg" :class="{ 'r-nvg_show': tNvgShow }">
        <div
          class="item"
          :key="item.id"
          @click="scrollToSection(item.idN)"
          v-for="item in detailNvgList">
          {{ $t(item.lang) }}
        </div>
      </div>

      <div class="dropdown-box" @click="changeLanguage()">
        <i class="iconfont icon-return" @click="goHome"></i>
        <div class="nag nag-lang">
          <i class="iconfont icon--diqiu"></i>
          <span class="lang">{{ $t('home.lang') }} </span>
        </div>
      </div>
    </div>

    <div class="banner-box">
      <!-- <i class="el-icon-picture-outline"></i> -->
      <!-- <i class="el-icon-refresh-right"></i> -->
      <!-- <div slot="error" class="image-slot">
      </div> -->
      <!-- <i class="el-icon-loading"></i> -->
      <!-- <i class="iconfont icon-jiazai iconfont-jiazai"></i> -->
      <!-- <i class="iconfont icon-jiazai1 iconfont-jiazai"></i> -->
      <div class="img-box img-box_error">
        <!-- <el-image lazy fit="cover" class="img" alt="" :src="carDetails.imgKV">
        </el-image> -->
        <picture>
          <source
            media="(max-width: 668px)"
            :srcset="carDetails.imgKV_mobile" />
          <img :src="carDetails.imgKV" />
        </picture>
      </div>

      <div class="title-new-h9">{{ carDetails.modelName }}</div>
    </div>
    <div class="car-color_box" id="highlights">
      <div class="h9-720" v-if="id_ == 1" @click="goNewPage2">
        <div class="h9-720-img">
          <div>
            <img alt="" class="zhuan-img" src="./../assets/img/zhaun_1.png" />
          </div>
          <div class="text-720">720</div>
        </div>
        <div class="h9-720-btn txt-uppercase">Click To Enter</div>
      </div>
      <div class="car-color">
        <div :class="['fade-box', showLoad ? 'img-box_error' : '']">
          <el-image
            lazy
            fit="cover"
            :key="index"
            :src="item.front_45_side"
            class="img fade-img"
            v-for="(item, index) in carDetails.exterior"
            :class="{ active: carIndex === index }"></el-image>
        </div>
      </div>
      <div class="car-color_bg">
        <div class="car-select">
          <div
            :key="item.id"
            class="car car1"
            @click="clickColorCar(index)"
            :class="{ 'car-ac': carIndex === index }"
            v-for="(item, index) in carDetails.exterior">
            <el-image
              lazy
              fit="cover"
              class="img"
              :src="item.front_color"></el-image>
          </div>
        </div>
      </div>
    </div>
    <!-- ------------------------ banner **end ------------------------ -->
    <div class="param-box" id="specifications">
      <div class="line">
        <div class="car-naem_line">
          <div class="car-naem_text"></div>
        </div>
      </div>
      <div class="param">
        <el-carousel
          :autoplay="false"
          :height="paramH"
          :arrow="carConfigData.length > 1 ? 'always' : 'never'">
          <el-carousel-item
            :key="item.id"
            :name="`carousel${index}`"
            v-for="(item, index) in carConfigData">
            <div class="car-naem hq-title1">{{ langShow(item.t) }}</div>
            <div class="box">
              <div class="item" :key="item2.id" v-for="item2 in item.arr">
                <div class="item-n">{{ langShow(item2.n) }}</div>
                <div class="item-v">{{ item2.prop_valCttEn }}</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="btn" @click="goNewPage">{{ $t('public.learnMore') }}</div>
    </div>
    <!-- ------------------------ banner **end ------------------------ -->
    <!-- ------------------------ 外 ** ------------------------ -->
    <div class="model-box" id="exterior">
      <div class="hq-title1">{{ langShow(carDetails.exterior1) }}</div>
      <div class="swiper-box">
        <swiper :key="refreshKey" ref="swiperModel" :options="modelOptions">
          <!-- <swiper-slide :key="i" v-for="(item, i) in modelList"> -->
          <!-- @click="clickPreview(i)" -->
          <!-- :initial-index="initialIndex" -->
          <swiper-slide
            :key="i"
            v-for="(item, i) in carDetails.exterior1.exteriorArr">
            <div class="model-item">
              <div class="img-box img-box_error">
                <!-- :key="i" -->
                <el-image
                  fit="cover"
                  :src="item.img"
                  class="model-img"
                  :preview-src-list="carDetails.exteriorSrcList"></el-image>
              </div>
              <div class="title">{{ langShow(item.title) }}</div>
              <div class="text">{{ langShow(item.text) }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- ------------------------ 内 ** ------------------------ -->
    <div class="model-box" id="Interior">
      <div class="hq-title1">{{ langShow(carDetails.interior) }}</div>
      <div class="swiper-box">
        <swiper :key="refreshKey" ref="swiperModel" :options="modelOptions">
          <!-- <swiper-slide :key="i" v-for="(item, i) in modelList"> -->
          <swiper-slide
            :key="i"
            v-for="(item, i) in carDetails.interior.interiorArr">
            <div class="model-item">
              <div class="img-box img-box_error">
                <!-- lazy -->
                <!-- scroll-container=".swiper-wrapper" -->
                <el-image
                  :key="i"
                  fit="cover"
                  :src="item.img"
                  class="model-img"
                  :preview-src-list="carDetails.interiorSrcList"></el-image>
                <!-- <img :src="item.img" class="model-img" loading="lazy" /> -->
              </div>
              <div class="title">{{ langShow(item.title) }}</div>
              <div class="text">{{ langShow(item.text) }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- ---------------------------------------------------- -->
    <div class="video-mask" id="video">
      <div class="hq-title1" @click="changeVideo()">
        {{ $t('public.video') }}
      </div>
      <div class="video-box">
        <video
          ref="video"
          muted=""
          loop="loop"
          autoplay=""
          x5-playsinline=""
          playsinline="true"
          class="video"
          webkit-playsinline="true"
          @ended="videoIsPlay = false"
          :src="carDetails.video"
          @play="videoPlay"
          @pause="videoUause"></video>
        <i
          v-if="videoIsPlay"
          @click="changeVideo()"
          class="play-btn el-icon-video-pause"></i>
        <i
          v-else
          @click="changeVideo()"
          class="play-btn el-icon-video-play"></i>
      </div>
    </div>
    <!-- 主图轮播 -->
    <div class="swiper-wrap" id="gallery">
      <div class="hq-title1">{{ $t('public.gallery') }}</div>
      <div class="swiper-box">
        <swiper
          ref="swiperMain"
          :options="mainOptions"
          class="gallery-top"
          @slide-change="onMainSlideChange">
          <swiper-slide v-for="(item, i) in carDetails.galleryArr" :key="i">
            <div class="img-box img-box_error">
              <el-image
                lazy
                :src="item.img"
                class="main-img"
                fit="cover"
                :preview-src-list="carDetails.gallerySrcList">
                <!-- <div slot="error" class="image-slot"> -->
                <!-- <i class="el-icon-loading"></i> -->
                <!-- <i class="iconfont icon-jiazai iconfont-jiazai"></i> -->
                <!-- <i class="iconfont icon-jiazai1 iconfont-jiazai"></i> -->
                <!-- </div> -->
              </el-image>
            </div>
          </swiper-slide>
        </swiper>
        <!-- 自定义箭头 -->
        <div class="custom-arrow prev" @click="prevSlide">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </div>
        <div class="custom-arrow next" @click="nextSlide">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </div>
      </div>
      <!-- 缩略图轮播 -->
      <swiper
        ref="swiperThumb"
        :options="thumbOptions"
        class="gallery-thumbs"
        @click-slide="onThumbClick">
        <swiper-slide v-for="(item, i) in carDetails.galleryArr" :key="i">
          <div class="thumb-item img-box_error">
            <el-image
              lazy
              fit="cover"
              class="thumb-img"
              :src="`${item.img}?iopcmd=thumbnail&type=4&width=400&quality=60`">
              <!-- <div slot="error" class="image-slot">
                <i class="el-icon-loading"></i>
              </div> -->
            </el-image>
            <div
              class="thumb-mask"
              :class="{ active: currentIndex === i }"></div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
// import { debounce } from 'lodash'
import { throttle } from 'lodash'
import { EventBus } from '@/assets/js/event-bus'
import {
  // carConfigData,
  // carColorIcon,
  // aboutList,
  // eventsList,
  // InteractList,
  imgBase,
  modelList,
  detailNvgList,
} from '@/assets/js/static'
import { langMixins } from '@/mixins/langMixins'
import {
  modelDetailsApi,
  modelPropParameterApi,
  // modelListApi,
} from '@/Api/requestApi'
// import PageHeader from "@/components/PageHeader.vue";
import FooterPage from '@/components/FooterPage.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'CarDetails',
  mixins: [langMixins],
  components: {
    // PageHeader,
    FooterPage,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      // initialIndex: 0,
      showLoad: true,
      // carConfigData,
      carConfigData: [],
      carIndex: 3,
      detailNvgList,
      modelList,
      // carColorIcon,
      // aboutList,
      // eventsList,
      // InteractList,
      currentIndex: 0,
      mainSwiper: null,
      scrollHandler: null,
      mainOptions: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'slide',
        speed: 300,
      },
      thumbSwiper: null,
      thumbOptions: {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: false,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      modelSwiper: null,
      modelOptions: {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1.8,
        // centeredSlides: true,
        freeMode: false,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        effect: 'slide',
        // speed: 300,
      },
      tNvgShow: false,
      windowWidth: 0,
      refreshKey: 0,
      carDetails: {
        imgKV: '',
        imgKV_mobile: '',
        exterior: [],
        exteriorSrcList: [],
        interiorSrcList: [],
        gallerySrcList: [],
        galleryArr: [],
        // interior: {},
        modelName: '',
        exterior1: { zh: '', en: '', exteriorArr: [] },
        interior: { zh: '', en: '', interiorArr: [] },
      },
      paramH: '290px',
      id_: '',
      videoIsPlay: false,
    }
  },
  mounted() {
    this.id_ = this.$route?.query?.id
    this.carIndex = this.$route?.query?.cI - 0 || 0
    console.log('this.$route?.query :>> ', this.$route?.query)
    // console.log('    this.$i18n.locale  :>> ', this.$i18n.locale)
    this.modelDetailsFn()
    this.modelParameterFn()
    this.$nextTick(() => {
      this.scrollHandler = throttle(this.handleResize, 200)
      window.addEventListener('resize', this.scrollHandler)
      this.handleResize()
      this.langFn('/carDetails', this.$route?.query?.id)
      // console.log('22222 :>> ', 22222)
      // 获取 Swiper 实例
    })
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    console.log('mounted ')
  },
  methods: {
    handleResize() {
      console.log('handleResize- :>>CarDetails1122 ')
      let ww_ = window.innerWidth

      if (ww_ < 768) {
        this.paramH = '380px'
        this.modelOptions.slidesPerView = 1.2
        // this.modelOptions.centeredSlides =true
        // console.log('111111 :>> ')
      } else if (ww_ < 992) {
        this.paramH = '340px'
        this.modelOptions.slidesPerView = 1.4
        // this.modelOptions.centeredSlides =true
      } else {
        this.paramH = '290px'
        // console.log('2222222 :>> ')
        this.modelOptions.slidesPerView = 1.8
        // this.modelOptions.centeredSlides =true
      }

      this.mainSwiper = this.$refs.swiperMain?.$swiper
      this.thumbSwiper = this.$refs.swiperThumb?.$swiper
      // this.modelSwiper = this.$refs.swiperModel?.$swiper
      this.modelSwiper = this.$refs.swiperModel
      // console.log(' this.mainSwiper  :>>1 ', this.mainSwiper)
      // console.log('    this.modelSwiper :>>2 ', this.modelSwiper)
      // console.log('this.modelSwiper :>>2 ', this.$refs.swiperModel)
      this.refreshKey++
      // 方法1：通过监听主图变化来同步缩略图
      if (this.mainSwiper && this.thumbSwiper) {
        this.mainSwiper.on('slideChange', () => {
          const newIndex = this.mainSwiper.activeIndex
          this.currentIndex = newIndex
          console.log('newIndex :>> ', newIndex)
          if (this.thumbSwiper && this.thumbSwiper.activeIndex !== newIndex) {
            this.thumbSwiper.slideTo(newIndex, 300)
          }
        })
        this.currentIndex = 0
      }
      this.windowWidth = ww_
    },
    async modelParameterFn() {
      let id_ = this.$route.query.id
      const {
        data: { code, data, modelList },
      } = await modelPropParameterApi({
        propt_id: 10001,
        // id: '1',
        // id: '2',
        id: id_,
      })
      // console.log('modelList :>> 888', JSON.parse(modelList[0].model_style))
      let carConfig_ = []

      if (code == 200) {
        // console.log('data :>> 55', data)
        let mn_ = JSON.parse(modelList[0].model_style)
        // console.log('mn_ :>>444 ', mn_)
        for (let key in data) {
          // console.log('object :>> ', key - 0)
          // console.log('object :>>22 ', data[key])
          // return
          // console.log('data[i :>> 8888888', data[i])
          let list_ = data[key].slice(0, 6)
          let temp = []
          // console.log('mn_[key] :>> ', mn_[0])
          let { car_model, car_modelEn } = mn_[key - 1]
          for (let j = 0; j < list_.length; j++) {
            let { prop_name, prop_nameEn, prop_valCttEn } = list_[j]
            temp.push({
              id: j + 1,
              prop_valCttEn,
              n: { zh: prop_name, en: prop_nameEn },
            })
          }
          carConfig_.push({
            arr: temp,
            t: { zh: car_model, en: car_modelEn.replace('version', '') },
          })
        }
        this.carConfigData = carConfig_
        console.log('carConfig_ :>> ', carConfig_)
      }
    },
    async modelDetailsFn() {
      const {
        data: { code, data },
      } = await modelDetailsApi({ id: this.$route.query.id })

      if (code == 200) {
        let {
          id,
          exterior,
          imgKV,
          imgKV_mobile,
          video,
          modelName,
          highlight,
          gallery,
        } = data
        let exterior_ = []

        for (let i = 0; i < exterior.length; i++) {
          const { front_45_side, front_color } = exterior[i]
          exterior_.push({
            id: i + 1,
            front_color: `${imgBase}${front_color}`,
            front_45_side: `${imgBase}${front_45_side}?iopcmd=thumbnail&type=4&width=1000&quality=60`,
          })
        }

        let highlight_ = JSON.parse(highlight)
        let gallery_ = JSON.parse(gallery)

        // console.log('highlight_ :>> ', highlight_)
        // console.log('gallery_ :>> ', gallery_)
        let {
          interior,
          interiorEn,
          interiorArr,
          eteriorDetails,
          eteriorDetailsEn,
          exteriorDetailsArr,
        } = highlight_

        let interior_ = []
        let interiorSrcList = []
        for (let i = 0; i < interiorArr.length; i++) {
          const { highImg, text, textEn, title, titleEn } = interiorArr[i]
          interior_.push({
            id: i + 1,
            title: { zh: title, en: titleEn },
            text: { zh: text, en: textEn },
            img: `${imgBase}${highImg}`,
            // img: `${imgBase}${highImg}?iopcmd=thumbnail&type=4&width=980&quality=60`,
          })
          interiorSrcList.push(`${imgBase}${highImg}`)
        }

        let exterior__ = []
        let exteriorSrcList = []
        for (let i = 0; i < exteriorDetailsArr.length; i++) {
          const { highImg, text, textEn, title, titleEn } =
            exteriorDetailsArr[i]
          exterior__.push({
            id: i + 1,
            title: { zh: title, en: titleEn },
            text: { zh: text, en: textEn },
            img: `${imgBase}${highImg}`,
            // img: `${imgBase}${highImg}?iopcmd=thumbnail&type=4&width=980&quality=60`,
          })
          exteriorSrcList.push(`${imgBase}${highImg}`)
        }
        let _gallery_ = []
        let gallerySrcList = []

        for (let i = 0; i < gallery_.length; i++) {
          _gallery_.push({
            id: i + 1,
            img: `${imgBase}${gallery_[i]}`,
            // img: `${imgBase}${gallery_[i]}?iopcmd=thumbnail&type=4&width=1600&quality=60`,
          })
          gallerySrcList.push(`${imgBase}${gallery_[i]}`)
        }

        // console.log('object :>> ', JSON.parse(highlight))

        this.carDetails = {
          id,
          modelName,
          exteriorSrcList,
          interiorSrcList,
          gallerySrcList,
          exterior: exterior_,
          imgKV: `${imgBase}${imgKV}`,
          video: `${imgBase}${video}`,
          galleryArr: _gallery_,
          exterior1: {
            zh: eteriorDetails,
            en: eteriorDetailsEn,
            exteriorArr: exterior__,
          },
          imgKV_mobile: `${imgBase}${imgKV_mobile}`,
          interior: { zh: interior, en: interiorEn, interiorArr: interior_ },
        }
        console.log(' this.carDetails  :>> ', this.carDetails)
        // console.log('gallery_ :>> ', gallery_)
        // console.log('data :>> ', data)
        // return this.$message({
        // type: 'success',
        // message: `${}`,
        // })
      }
    },
    // clickPreview(i) {
    //   console.log('i :>> ', i)
    //   this.initialIndex = i
    // },
    // clickCar(i) {},
    clickColorCar(i) {
      this.showLoad = false
      this.carIndex = i
      // this.$refs.carouselRef.setActiveItem(`carousel${i}`)
    },
    // 主图切换事件
    onMainSlideChange() {
      if (this.mainSwiper && this.thumbSwiper) {
        const newIndex = this.mainSwiper.activeIndex
        this.currentIndex = newIndex
        if (this.thumbSwiper.activeIndex !== newIndex) {
          this.thumbSwiper.slideTo(newIndex, 300)
        }
      }
    },
    // 缩略图点击事件
    onThumbClick(e) {
      this.mainSwiper.slideTo(e, 100)
      this.thumbSwiper.slideTo(e, 100)
      this.currentIndex = e
    },
    // 上一张
    prevSlide() {
      // console.log('点击上一张', this.mainSwiper)
      if (this.mainSwiper) {
        this.mainSwiper.slidePrev()
        this.currentIndex = this.mainSwiper.activeIndex
        // console.log('当前索引:', this.mainSwiper.activeIndex)
      }
    },
    // 下一张
    nextSlide() {
      // console.log('点击下一张', this.mainSwiper)
      if (this.mainSwiper) {
        this.mainSwiper.slideNext()
        this.currentIndex = this.mainSwiper.activeIndex
        // console.log('当前索引:', this.mainSwiper.activeIndex)
      }
    },
    goNewPage() {
      // console.log('66666666 :>> ', 66666666)
      this.$router
        .push({
          path: '/paramDetails',
          query: { id: this.$route.query.id, lang: this.$i18n.locale },
          // query: { vem_vid, vem_id, ve_id, brand_id },
        })
        .catch(() => {})
    },
    goHome() {
      // console.log('66666666 :>> ', 66666666)
      this.$router
        .push({
          path: '/',
          query: { lang: this.$i18n.locale },
          // query: { vem_vid, vem_id, ve_id, brand_id },
        })
        .catch(() => {})
    },
    scrollToSection(sectionId) {
      const targetElement = document.getElementById(sectionId)
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },
    langShow(p) {
      if (!p) {
        return ''
      }
      return p[this.$i18n.locale]
    },
    changeLanguage() {
      let lang_ = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = lang_
      window.sessionStorage.setItem('sessionLang', lang_)
      let query_ = { lang: lang_, id: this.id_ }
      this.$router
        .push({ path: this.$route.path, query: query_ })
        .catch(() => {})
      EventBus.$emit('message', lang_)
    },
    goNewPage2() {
      window.open(
        'https://www.hongqi-auto.com/3D/abbr/3Dexhibition/ehs9_720/?from=official_site',
        '_blank'
      )
    },
    videoPlay() {
      this.videoIsPlay = true
      // console.log('videoPlay :>> ')
    },
    videoUause() {
      // console.log('videoUause :>> ')
      this.videoIsPlay = false
    },
    changeVideo() {
      // console.log('11 :>> ', 11)
      const video = this.$refs.video
      if (video.paused) {
        video.play()
        this.videoIsPlay = true
      } else {
        video.pause()
        this.videoIsPlay = false
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scrollHandler)

    // 清理事件监听
    if (this.mainSwiper) {
      this.mainSwiper.off('slideChange')
    }
    if (this.thumbSwiper) {
      this.thumbSwiper.off('click')
    }
  },
}
</script>

<style lang="scss" scoped>
.hq-title1 {
  font-size: 28px;
}
@keyframes zhuan {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.top-nvg_box {
  width: 100%;
  padding: 0 1.25em;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.8);
  color: #f2f2f2;
  z-index: 1999;
  .logo-box {
    width: 60px;
    // margin-right: auto;
    // margin-right: 1.25em;
    cursor: pointer;
  }
  .icon-danlieliebiao {
    display: none;
  }
  .dropdown-box {
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 50%;
    right: 1em;
    transform: translate(0%, -50%);
    .icon-return {
      font-size: 26px;
      cursor: pointer;
      color: #fff;
    }
    .nag-lang {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .lang {
        // font-weight: 600;
      }
      .icon--diqiu {
        font-size: 16px;
        font-weight: 600;
        padding-right: 5px;
      }
    }
  }

  .r-nvg {
    margin: 0 auto;
    // margin-right: 72px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .item {
      display: block;
      padding-right: 40px;
      white-space: nowrap;
      font-weight: 700;
      font-size: 14px;
      line-height: 70px;
      cursor: pointer;
    }
  }
}
// ------------------------ banner**start ------------------------
.banner-box {
  // margin-top: 68px;
  position: relative;
  padding-top: 70px;
  background-color: #000;
  max-height: 100vh;
  overflow: hidden;
  .img-box_error {
    background-size: 8%;
  }
  .img-box {
    width: 100%;
    aspect-ratio: 16 / 7;
    background-color: #fafafa;

    .img {
      width: 100%;
      aspect-ratio: 16 / 7;
      object-fit: cover;
    }
  }

  .title-new-h9 {
    position: absolute;
    top: 140px;
    left: 50%;
    transform: translate(-50%, 0%);
    font-size: 3.125vw;
    text-align: center;
    font-family: 'HongqiFontBold';
    color: #fff;
  }
}
// ------------------------ car-color**start ------------------------
.car-color_box {
  width: 100%;
  padding: 150px 0 80px;
  // margin-top: 60px;
  position: relative;
  .h9-720 {
    position: absolute;
    top: 80px;
    right: 15%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1899;
    .h9-720-img {
      width: 8.76vw;
      position: relative;
      .zhuan-img {
        width: 100%;
        height: 50% !important;
        animation: zhuan 5s linear infinite;
      }
      .text-720 {
        position: absolute;
        left: -0.5vw;
        right: 0;
        top: 3.2vw;
        margin: auto;
        z-index: 1;
        text-align: center;
        font-size: 2vw;
        font-weight: 900;
        transform: translateX(0) rotateX(0);
      }
    }
    .h9-720-img > div {
      transform: translateX(0) rotateX(63deg);
    }
    .h9-720-btn {
      font-size: 1.2vw;
      font-weight: 700;
      // transform: translateY(-1.2vw);
      color: #333;
    }
  }
  .car-color {
    // max-width: 40vw;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .fade-box {
    position: relative;
    aspect-ratio: 16 / 6.8;
    overflow: hidden;
    z-index: 999;
    .fade-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      aspect-ratio: 13 / 5.2;
      object-fit: cover;
      opacity: 0;
      transition: opacity 0.6s ease;
    }
    .fade-img.active {
      opacity: 1;
      // background-color: #fafafa;
    }
    .img {
      width: 100%;
    }
  }

  .car-select {
    position: absolute;
    bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 9999;
    .car {
      width: 50px;
      height: 50px;
      margin: 0 5px;
      border-radius: 50%;
      overflow: hidden;
      border: solid 3px #fff;
      cursor: pointer;
      .img {
        width: 100%;
        // height: 100%;
      }
    }
    .car:hover {
      border: solid 3px #333;
    }
    .car-ac {
      border: solid 3px #333;
    }
  }
  .car-color_bg {
    width: 100%;
    height: 40%;
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    // background-color: #f00;
    background-color: #f1f1f1;
    z-index: 97;
  }
}
// ------------------------ param-box**start ------------------------
.param-box {
  width: 100%;
  padding: 30px 0;
  margin-top: 60px;
  // border: #000 solid 1px;
  // background-color: #f1f1f1;
  position: relative;

  .line {
    width: 100%;
    position: absolute;
    top: 112px;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    .car-naem_line {
      width: 100%;
      height: 1px;
      margin: 24px 0;
      position: relative;
      background-color: #dcdfe6;

      .car-naem_text {
        width: 450px;
        height: 4px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        background-color: #fff;
        padding: 0 20px;
        // font-weight: 500;
        // color: #303133;
      }
    }
  }

  ::v-deep .el-carousel__arrow {
    top: 50px;
    background-color: #333;
  }
  ::v-deep .el-carousel__arrow--left {
    left: 32%;
  }
  ::v-deep .el-carousel__arrow--right {
    right: 32%;
  }
  .param {
    max-width: 1200px;
    padding-top: 30px;
    margin: 0 auto;
    .car-naem {
      padding-top: 20px;
      line-height: 60px;
      // text-align: center;
    }
    .box {
      padding-top: 40px;
      margin: 0 70px;
      // width: 100%;
      display: flex;
      align-items: center;
      // flex-wrap: wrap;
      flex-wrap: wrap;

      .item {
        // width: 20%;s
        width: 33.33%;
        margin-bottom: 20px;
        .item-n {
          font-size: 14px;
          text-align: center;
        }
        .item-v {
          font-size: 20px;
          font-weight: 600;
          text-align: center;
        }
      }
    }
  }
  .btn {
    width: 150px;
    margin: 0 auto;
    font-size: 18px;
    line-height: 46px;
    // font-weight: bolder;
    // font-family: 'HongqiFontBold';
    text-align: center;
    cursor: pointer;
    color: #fff;
    background-color: #333;
  }
}

.video-mask {
  padding: 60px 10px 0;
  .hq-title1 {
    padding-bottom: 60px;
  }
  .video-box {
    position: relative;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    aspect-ratio: 16 / 9;
    background-color: #fafafa;
    .video {
      width: 100%;
      aspect-ratio: 16 / 9;
      margin: 0 auto;
      object-fit: cover;
      background: #000;
      border-radius: 10px;
      overflow: hidden;
    }
    .play-btn {
      position: absolute;
      bottom: 20px;
      left: 20px;
      font-size: 50px;
      z-index: 999;
      color: #fafafa;
    }
  }
}

.model-box {
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 20px;
  .hq-title1 {
    padding: 60px 0;
  }
  .model-item {
    .img-box {
      overflow: hidden;
      aspect-ratio: 16 / 9;
      border-radius: 10px;
      // background-color: #fafafa;
      .model-img {
        aspect-ratio: 16 / 9;
        object-fit: cover;
      }
    }

    .title {
      font-size: 28px;
      padding-top: 1.2vw;
      padding-bottom: 1.4vw;
    }
    .text {
      font-size: 0.8vw;
    }
  }
  .swiper-box {
    position: relative;
    cursor: pointer;
    /* 自定义箭头按钮 */
    .custom-arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 44px;
      height: 44px;
      background: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(4px);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 888;
      transition: all 0.3s ease;
      opacity: 0.4;
    }

    .custom-arrow.prev {
      left: 20px;
    }

    .custom-arrow.next {
      right: 20px;
    }
  }
}

// ------------------------ swiper**start ------------------------
.swiper-wrap {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 80px 0;
  border-radius: 10px;
  overflow: hidden;
  .hq-title1 {
    padding-bottom: 60px;
  }
  .swiper-slide {
    border-radius: 10px;
    overflow: hidden;
  }
  .swiper-box {
    position: relative;
  }
  /* 主图样式 */
  .gallery-top {
    overflow: hidden;
    .img-box {
      aspect-ratio: 16 / 9;
      background-color: #fafafa;
    }
    .main-img {
      width: 100%;
      aspect-ratio: 16 / 9;
      object-fit: cover;
      display: block;
    }
  }
  .swiper-slide {
    // width: 100% !important;
  }

  /* 自定义箭头按钮 */
  .custom-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
    opacity: 0.8;
  }

  .custom-arrow.prev {
    left: 20px;
  }

  .custom-arrow.next {
    right: 20px;
  }
}

/* 缩略图样式 */
.gallery-thumbs {
  margin-top: 8px;
}

.thumb-item {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s;
  aspect-ratio: 16 / 9;
  .thumb-img {
    aspect-ratio: 16 / 9;
    width: 100%;
    object-fit: cover;
    display: block;
  }

  /* 缩略图遮罩效果 */
  .thumb-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    transition: all 0.3s ease;
    pointer-events: none;
  }

  /* 当前激活的缩略图 - 无遮罩 */
  .thumb-mask.active {
    background: transparent;
    box-sizing: border-box;
  }
}

.thumb-item:hover {
  transform: scale(1.02);
}

@import './css/CarDetails-media.scss';
</style>
